<template>
  <div>Please wait..</div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "AuthHandler",
  methods: mapActions(['finalizeLogin']),
  created() {
    //--lifecyle method called just after component is created
    this.finalizeLogin(window.location.hash);
  }
};
</script>